import { render } from "./index.vue?vue&type=template&id=c701997c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/templates/default-entry/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c701997c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c701997c', __exports__)) {
    api.reload('c701997c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c701997c", () => {
    api.rerender('c701997c', render)
  })

}


export default __exports__